import { Button, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import {  useCustomNavigate } from "core/hooks/useCustomNavigate";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { getFieldInputProps } from "core/utils/form";
import { _t } from "core/language";
import { useEffect, useState } from "react";
import BottomNavigation from "core/layouts/BottomNavigation";
import { validationSchemaChangePassword } from "modules/Auth/pages/Auth.config";
import API from "core/networks/API";
import { API_CHANGE_PASSWORD } from "../api";
import { useDispatch } from "react-redux";
import * as action from "modules/Auth/store/actions";
import { hideBottomButtonInputFocus } from "core/utils/helper";
import { useRecipe } from "modules/Ingredients/hooks/recipe";

const ChangePassword = () => {
  const { resetRecipes } = useRecipe()
  const navigate = useCustomNavigate();
  const dispatch = useDispatch();

  const formik = useFormikCustom({
    initialValues: {
      password: "",
      rePassword: "",
      validSubmit: false,
    },
    validationSchema: validationSchemaChangePassword,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values, formikHelpers) {
      console.log(values, formikHelpers)
      
      handleChangePassword()
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });

  useEffect(() => {
    hideBottomButtonInputFocus()
  }, [])

  const [validSubmit, setValidSubmit] = useState(true);
  useEffect(() => {
    setValidSubmit(formik.values.password && formik.values.rePassword ? false : true);
  }, [formik])

  const handleChangePassword = async () => {
    const dataRequest = {
      password: formik.values.password,
    }
    
    try {
      const { data: response } = await API.post(`${API_CHANGE_PASSWORD}`, dataRequest)
      if (response && response?.code === 200) {
        console.log('chang success')
        dispatch(action.logOutRequest());
      }
    } catch (e: any) {
      console.log(e, 'errors')
      const msgError = e?.response?.data?.msg || 'ERROR SERVER'
      formik.setErrors({ password: msgError })
    }
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmit = (e: any) => {
    const { onSubmit, errors } = formik;
    console.log(errors, 'errors')
    onSubmit(e)
  };


  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader sticky title={_t('auth.LabelResetPassword')} handleGoBack={handleGoBack} />
      <div className="">
        <form onSubmit={handleSubmit} className="flex flex-col px-4 py-12 w-full ">
          <div className="">
            <CInputControl
              className=" "
              label={_t('auth.NewPassword')}
              error=""
              maxLength={200}
              type="password"
              placeholder={_t('auth.PlaceHolderPassword')}
              {...getFieldInputProps(formik, 'password')}
            />
            <CInputControl
              className=""
              label={_t('auth.ConfirmNewPassword')}
              error=""
              maxLength={200}
              type="password"
              placeholder={_t('auth.VerifyPassword')}
              {...getFieldInputProps(formik, 'rePassword')}
            />
          </div>
          <div className="bottom-btn absolute left-0 bottom-[60px] w-full px-4">
            <Button disabled={validSubmit} size="lg" type="submit" label={_t('auth.Confirm')} classBtn="w-full mb-[50px]" />
          </div>
        </form>
      </div >
      <BottomNavigation activeIndex={5} onNavigateChange={resetRecipes} />
    </AppLayout >
  );
};

export default ChangePassword;
